import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import {
  LocationOn as LocationOnIcon,
  Visibility as VisibilityIcon,
  CreditCard as CreditCardIcon,
} from "@mui/icons-material";
import { ActionsButtons } from "components/CustomButtons/ActionsButtons";
import { ModalV2 } from "components/Modal/ModalV2";
import { CreditConditionsDetails } from "./CreditConditionsDetails";
import { DataFiscal } from "./DataFiscal";
import { ShipToAddressDetails } from "./ShipToAddressDetails";
import { useRuleValidator } from "hooks/useRuleValidator";
import { useToggle } from "hooks/useToggle";
import { PERMISSIONS } from "router/permissions";
import {
  getDataFiscalAction,
  getCreditConditionsAction,
  getShipToAddressAction,
} from "redux/actions/erpEquivalencies/erpEquivalenciesActions";

const { CRM_EQUIVALENCE_ERP_GN4_CONDITIONS, CRM_EQUIVALENCE_ERP_GN4_CONDITIONS_WHOLE } = PERMISSIONS;
const SHIP_TO_TYPE = "SHIP_TO";

export const ActionsCell = ({ original }) => {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useToggle();
  const [shipToModal, setShipToModal] = useToggle();
  const [creditConditionsModal, setCreditConditionsModal] = useToggle();
  const [loadingFiscalData, setLoadingFiscalData] = useState(false);
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [loadingConditions, setLoadingConditions] = useState(false);
  const canViewPartialConditions = useRuleValidator(CRM_EQUIVALENCE_ERP_GN4_CONDITIONS);
  const canViewAllConditions = useRuleValidator(CRM_EQUIVALENCE_ERP_GN4_CONDITIONS_WHOLE);

  const { idAccount, idCustomer, idStation, gn4Account, siteUseCode } = original;
  const canViewCreditConditions = canViewPartialConditions || canViewAllConditions;
  const isShipToType = siteUseCode === SHIP_TO_TYPE;

  const handleOpenModal = useCallback(async () => {
    setLoadingFiscalData(true);
    const success = await dispatch(getDataFiscalAction(idAccount, idCustomer, idStation));
    setLoadingFiscalData(false);
    if (success) setOpenModal();
  }, [idAccount, idCustomer, idStation]);

  const handleShipToModal = useCallback(async () => {
    setLoadingAddress(true);
    const success = await dispatch(getShipToAddressAction({ idAccount }));
    setLoadingAddress(false);
    if (success) setShipToModal();
  }, [idAccount]);

  const handleCreditConditionsModal = useCallback(async () => {
    setLoadingConditions(true);
    const success = await dispatch(getCreditConditionsAction({ idAccount }));
    setLoadingConditions(false);
    if (success) setCreditConditionsModal();
  }, [idAccount]);

  const buttons = [
    {
      Icon: VisibilityIcon,
      color: 0,
      onClick: handleOpenModal,
      loading: loadingFiscalData,
      tooltip: "Ver datos fiscales",
    },
    {
      Icon: LocationOnIcon,
      color: 0,
      validation: isShipToType,
      onClick: handleShipToModal,
      loading: loadingAddress,
      tooltip: "Domicilio Ship to",
    },
    {
      Icon: CreditCardIcon,
      color: 0,
      validation: canViewCreditConditions && isShipToType,
      onClick: handleCreditConditionsModal,
      loading: loadingConditions,
      tooltip: "Condiciones de crédito",
    },
  ];

  return (
    <>
      <ActionsButtons buttons={buttons} />
      <ModalV2
        open={openModal}
        onClose={setOpenModal}
        title="Datos fiscales"
        toRight
      >
        <DataFiscal />
      </ModalV2>
      <ModalV2
        open={shipToModal}
        onClose={setShipToModal}
        title="Domicilio - SHIP TO"
        customWidth="100%"
      >
        <ShipToAddressDetails gn4Account={gn4Account} />
      </ModalV2>
      <ModalV2
        open={creditConditionsModal}
        onClose={setCreditConditionsModal}
        title={<>Condiciones de crédito<br />SHIP TO {gn4Account}</>}
        toRight
      >
        <CreditConditionsDetails />
      </ModalV2>
    </>
  );
};
